import { render, staticRenderFns } from "./AgeRangeConfig.vue?vue&type=template&id=db4ddeaa&scoped=true&"
import script from "./AgeRangeConfig.vue?vue&type=script&lang=js&"
export * from "./AgeRangeConfig.vue?vue&type=script&lang=js&"
import style0 from "./AgeRangeConfig.vue?vue&type=style&index=0&id=db4ddeaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4ddeaa",
  null
  
)

export default component.exports